// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsArea/style.css
// module id = 3684
// module chunks = 30